import { AdminDeleteDialog } from "components/partials"
import { toTableData, deleteRows } from "common/helpers/admin-page-func.helper"
import { useAdminState, useAdminDispatch, ActionCreators } from "./Context"
import { CompaniesApi } from "./api"

const deleteSelected = deleteRows(CompaniesApi.remove)

const DeleteDialog = () => {
  const dispatch = useAdminDispatch()
  const { rowsToDelete, params } = useAdminState()
  const { filter, pagination } = params

  function onExited() {
    dispatch(ActionCreators.setToDelete(null))
  }

  async function deleteCallback() {
    if (!filter || !pagination) return
    if (!Array.isArray(rowsToDelete)) return

    let hasError = false

    try {
      await deleteSelected(rowsToDelete)
    } catch (error) {
      hasError = true
      throw error
    }

    if (!hasError) {
      const response = await CompaniesApi.get({ filter, pagination })
      dispatch(ActionCreators.loaded(toTableData(response)))
      dispatch(ActionCreators.setToEdit(null))
    }
  }

  return (
    <AdminDeleteDialog
      selected={rowsToDelete?.length || 0}
      deleteCallback={deleteCallback}
      DialogProps={{
        TransitionProps: {
          onExited
        }
      }}
    />
  )
}

export default DeleteDialog
